
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

export default function FeaturesSection() {
  const { t } = useTranslation('common');

  return (
    <section className="py-24 px-6 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-start mb-12">
          <div>
            <h2 className="text-5xl font-bold mb-2">
              <span className="text-gray-900">{t('features.title')}</span>
              <span className="text-teal-600">{t('features.titleHighlight')}</span>
            </h2>
            <p className="text-gray-600">{t('features.subtitle')}</p>
          </div>
          <div className="px-4 py-2 bg-gray-900 text-white text-sm rounded-full">
            {t('features.badge')}
          </div>
        </div>

        <div className="flex gap-6 overflow-x-auto pb-4 scrollbar-hide">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="min-w-[300px] bg-white rounded-2xl p-8 hover:shadow-lg transition-shadow"
          >
            <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mb-4">
              <i className="ri-team-line text-2xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              {t('features.network.title')}
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              {t('features.network.desc')}
            </p>
            <p className="text-3xl font-bold text-gray-900">
              {t('features.network.value')}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="min-w-[300px] bg-white rounded-2xl p-8 hover:shadow-lg transition-shadow"
          >
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
              <i className="ri-global-line text-2xl text-blue-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              {t('features.multilingual.title')}
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              {t('features.multilingual.desc')}
            </p>
            <p className="text-3xl font-bold text-gray-900">
              {t('features.multilingual.value')}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="min-w-[300px] bg-white rounded-2xl p-8 hover:shadow-lg transition-shadow"
          >
            <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mb-4">
              <i className="ri-customer-service-2-line text-2xl text-amber-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              {t('features.support.title')}
            </h3>
            <p className="text-sm text-gray-600">
              {t('features.support.desc')}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="min-w-[300px] bg-white rounded-2xl p-8 hover:shadow-lg transition-shadow"
          >
            <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4">
              <i className="ri-line-chart-line text-2xl text-green-600"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              {t('features.success.title')}
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              {t('features.success.desc')}
            </p>
            <p className="text-3xl font-bold text-gray-900">
              {t('features.success.value')}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
